__turbopack_context__.v({
  "message": "ErrorInterstitial-module__5PYtLq__message",
  "root": "ErrorInterstitial-module__5PYtLq__root",
});
